<template>
  <el-dialog
    title="素材重命名"
    :visible.sync="visible"
    width="563px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="54px"
      :rules="rules"
      class="name-ruleForm"
    >
      <el-form-item label="名称：" prop="name">
        <el-input placeholder="请输入素材名称" v-model.trim="ruleForm.name">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { modNameFetch } from "../../api/material";
export default {
  data() {
    return {
      visible: false,
      ruleForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请填写素材名称", trigger: "blur" }],
      },
      fileNames: "",
      folderId: null,
    };
  },

  methods: {
    handleClose() {
      this.visible = false;
      this.$emit("clearOptionValue");
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          modNameFetch({
            fileName: this.fileNames,
            modName: this.ruleForm.name,
          }).then((res) => {
            if (res.code == "0000") {
              this.$message.success("重命名成功");
              this.resetForm(formName);
              this.$emit("updateTags", this.folderId);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.name = "";
      this.handleClose();
    },
    showModal(name, folderId, fileNames) {
      this.visible = true;
      if (name) {
        this.ruleForm.name = name;
      }
      this.folderId = folderId;
      this.fileNames = fileNames;
    },
  },
};
</script>

<style lang="less"  >
.name-ruleForm {
  .el-form-item {
    margin-bottom: 0 !important;
  }
}
</style>